function eventWorkspaceId(pathname: string): string | null {
  const segments = pathname.split('/').filter(Boolean);
  if (segments[0] !== 'events' || !segments[1]) return null;
  return segments[1];
}

export function isSameEventWorkspaceNavigation(
  previousPathname: string | null | undefined,
  nextPathname: string,
): boolean {
  if (!previousPathname) return false;
  const previousEventId = eventWorkspaceId(previousPathname);
  const nextEventId = eventWorkspaceId(nextPathname);
  return Boolean(previousEventId && nextEventId && previousEventId === nextEventId);
}

/** Dates and filters change the current Schedule without leaving its workspace. */
export function isSameScheduleNavigation(
  previousPathname: string | null | undefined,
  nextPathname: string,
): boolean {
  return previousPathname === nextPathname && ['/schedule', '/calendar'].includes(nextPathname);
}
